'use client'

import { AdminBar } from '@onclicks/sharedcomponents/AdminBar'
import { useEffect, useState } from 'react'

export function DraftModeBar() {
  const [isPreview, setIsPreview] = useState(false)

  useEffect(() => {
    setIsPreview(document.cookie.includes('__prerender_bypass'))
  }, [])

  if (!isPreview) return null
  return <AdminBar adminBarProps={{ preview: true }} />
}
